import {useState} from 'react';

const Form = ({title, handleClick}) => {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    return (
        <section class="vh-100">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-2-strong" style={{borderRadius: 1+'rem',
            boxShadow: '0 4px 16px #4281dc'}}>
          <div class="card-body p-5 text-center">

            <h3 class="mb-5">{title}</h3>

            <div class="form-outline mb-4">
              <input type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="" class="form-control" className="form-control form-control-lg" />
              <label class="form-label" for="typeEmailX-2">Почта</label>
            </div>

            <div class="form-outline mb-4">
              <input type="password"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                placeholder="" id="typePasswordX-2" class="form-control form-control-lg" />
              <label class="form-label" for="typePasswordX-2">Пароль</label>
            </div>
            <button onClick={() => handleClick(email, pass)}  class="btn btn-primary btn-lg btn-block" type="submit">Войти</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    )
}

export {Form}
